import React, { useState } from 'react';
import { useContacts } from '../../context/ContactsContext';
import { useUISettings } from '../../context/UISettingsContext';
import { Button } from '../common/Button';

export function ContactModal() {
  const { isContactModalOpen, setIsContactModalOpen } = useUISettings();
  const { addContact } = useContacts();
  const [contactUuid, setContactUuid] = useState('');
  const [alias, setAlias] = useState('');
  
  if (!isContactModalOpen) return null;
  
  const handleSubmit = async () => {
    if (contactUuid.trim()) {
      await addContact(contactUuid.trim(), alias.trim() || null);
      setContactUuid('');
      setAlias('');
      setIsContactModalOpen(false);
    }
  };
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-2xl w-full max-w-md">
        <h3 className="text-xl font-bold mb-4 text-gray-800">Add Contact</h3>
        
        <input
          type="text"
          placeholder="Contact's UUID"
          value={contactUuid}
          onChange={(e) => setContactUuid(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg mb-4 focus:ring-2 focus:ring-blue-500"
          autoFocus
        />
        
        <input
          type="text"
          placeholder="Alias (optional)"
          value={alias}
          onChange={(e) => setAlias(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg mb-4 focus:ring-2 focus:ring-blue-500"
        />
        
        <div className="flex justify-end space-x-4">
          <Button onClick={() => setIsContactModalOpen(false)} variant="secondary">
            Cancel
          </Button>
          <Button 
            onClick={handleSubmit} 
            disabled={!contactUuid.trim()}
            variant="primary"
          >
            Add Contact
          </Button>
        </div>
      </div>
    </div>
  );
}